<div class="flex basis-[7%] flex-row">
    <div class="flex flex-auto justify-start items-center content-center">
        <h1>ASM Files</h1>
    </div>
</div>

<div class="filter-section grid grid-cols-5 gap-3 p-3">
    <div>
        <app-payer-select
        [form]="form"
        [multiple]="true"
        [selectAllEnabled]="true"
        [queryOptions]="true"
        [required]="true"
        (ready)="handlePayerFieldReady()"
        (valueChanged)="handlePayerValueChange($event)"></app-payer-select>
    </div>
    <div>
        <app-upload-date
        [form]="form"
        [required]="true"
        [label]="'Create Date'"
        (readyEvent)="handleCreateDateReady()"
        (valueChangedEvent)="handleCreateDateValueChange($event)"></app-upload-date>
    </div>
    <div class="pt-3">
        <button mat-flat-button class="primary-button"
          [disabled]="!generateEnabled"
          [matTooltip]="generateTooltip"
          [matTooltipClass]="'app-tooltip'"
        (click)="onGenerateReport()">Generate</button>
      </div>
</div>

<div class="grid-section flex-auto">
    <app-asm-files-grid></app-asm-files-grid>
</div>